module.exports = __webpack_public_path__ + "static/media/note.e30189ac.svg";